import {createStyledElement} from './createStyledElement';

/**
 * @deprecated
 */
export const Element = createStyledElement();
